import { render, staticRenderFns } from "./modalCreateEdit.vue?vue&type=template&id=701edae0"
import script from "./modalCreateEdit.vue?vue&type=script&lang=ts"
export * from "./modalCreateEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports